import { PostCancelBillingRequestBodyType } from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import {
  appSubscriptionKeys,
  organizationsKeys,
  subscriptionsKeys,
} from "../queryKeys";
import { ApiRequest } from "../types/api";

const cancelBilling = async (
  payload: ApiRequest<PostCancelBillingRequestBodyType>
) => {
  const resp = await api.post<any>(`/v2/organizations/cancel-billing`, {
    id: payload.body.id,
  });

  return resp.data;
};

export const useCancelBilling = () => {
  const queryClient = useQueryClient();
  return useMutation<
    ApiRequest<PostCancelBillingRequestBodyType>,
    Error,
    any,
    any
  >({
    mutationFn: async (payload: ApiRequest<PostCancelBillingRequestBodyType>) =>
      cancelBilling(payload),
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({ queryKey: organizationsKeys.one });
      await queryClient.invalidateQueries({
        queryKey: appSubscriptionKeys.all,
      });
      await queryClient.invalidateQueries({
        queryKey: subscriptionsKeys.all(true),
      });
    },
  });
};
